<template>
  <component
    :is="props.useClientLayout ? AdminLayout : PortalLayout"
    section="Alert History"
    title="Alert History"
    hideHeader
  >
    <div v-if="props.useClientLayout" class="pb-4">
      <BackButton to=".."> Back to Alert </BackButton>
    </div>
    <h1 class="py-3 mb-6 border-b flex">
      <div class="text-xl">
        <div class="font-bold">Alert History</div>
        <div>
          {{ property?.name }}
        </div>
      </div>
    </h1>
    <div class="mt-4">
      <Loading v-if="isPropertyLoading || isLoading" />
      <div v-else>
        <div class="mt-4" v-if="histories?.length > 0">
          <div class="mb-4">
            Found {{ histories?.length }}
            <span v-if="histories?.length === MAX_RESULTS">most recent </span>alerts.
          </div>
          <table class="table-auto w-full border-2 shadow text-sm">
            <thead class="font-sm font-bold">
              <tr>
                <td class="pl-3"></td>
                <td class="pl-3"><span class="md:inline hidden">First </span>Name</td>
                <td class="md:table-cell hidden pl-3">Last Name</td>
                <td class="pl-3 py-2">Email</td>
                <td class="px-3">Date Sent</td>
              </tr>
            </thead>
            <template v-for="(history, i) in histories" :key="i">
              <tr
                class="font-xs font-mono border-bottom-2 hover:border-sky-800 hover:bg-sky-300 cursor-pointer"
                :class="{ 'bg-stone-200': i % 2 === 0 }"
                @click="selectClick(history)"
              >
                <td class="pl-3">
                  <div class="px-2">
                    <IHeroiconsOutlineChevronUp
                      class="mx-auto"
                      :class="{
                        'transform rotate-180': history.alertHistoryId !== selectedHistoryId,
                      }"
                    />
                  </div>
                </td>
                <td class="pl-3">
                  {{ history.senderPersonFirstName }}
                  <span class="md:hidden xl:inline">
                    {{ history.senderPersonLastName }}
                  </span>
                </td>
                <td class="md:table-cell hidden pl-3">
                  {{ history.senderPersonLastName }}
                </td>
                <td class="pl-3">{{ history.senderPersonLoginEmail }}</td>
                <td class="px-3">{{ formatDateTime(history.dateSent) }}</td>
              </tr>
              <template v-if="history.alertHistoryId === selectedHistoryId">
                <tr>
                  <td :colspan="5" class="px-8 p-6 break-all">
                    <div class="font-bold">Message</div>
                    {{ history.messageText }}
                    <div class="mt-2 font-bold">Email List</div>
                    {{ history.emailList?.length === 0 ? "None." : history.emailList }}
                    <div class="mt-2 font-bold">SMS List</div>
                    {{ history.smsList?.length === 0 ? "None." : history.smsList }}
                    <div>
                      <RouterLink :to="'/staff/alert/detail/' + history.alertHistoryId"
                        >More Detail</RouterLink
                      >
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </table>
        </div>
        <div v-else class="mb-2">
          <span>-- No Alert History found for this building --</span>
        </div>
      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
import { useAlertStore } from "../../store/alertStore";
import { useBldgStore } from "../../store/bldgStore";
import { AlertHistoryDTO } from "../../store/generatedFetchClient";
import PortalLayout from "../../layouts/PortalLayout.vue";
import AdminLayout from "../../layouts/AdminLayout.vue";
import { formatDateTime } from "../../helpers";

const props = withDefaults(defineProps<{ useClientLayout: boolean }>(), {
  useClientLayout: false,
});

const bldgStore = useBldgStore();
const alertStore = useAlertStore();
var isPropertyLoading = computed(() => bldgStore.isLoading);
var isLoading = ref(false);
var property = computed(() => bldgStore.property);

var histories = computed(() => alertStore.histories);
const MAX_RESULTS = 30;

onMounted(loadData);
watch(property, loadData);

async function loadData() {
  if (property.value?.portalId) {
    isLoading.value = true;
    await alertStore.getHistory(property.value.portalId, MAX_RESULTS);
    console.log("Alert History loaded", histories);
    isLoading.value = false;
  }
}

let selectedHistoryId = ref(-1);

// Same item clicked twice => Toggle selection
function selectClick(history: AlertHistoryDTO) {
  console.log("selecttion toggle", history);
  selectedHistoryId.value =
    history.alertHistoryId === selectedHistoryId.value ? -1 : history.alertHistoryId;
}
</script>
